import actions from 'actions'
import { PERFORMANCES_VIEW_CURRENT } from 'constants/eventgroup-page-constants'

const defaultState = {
  performancesViewType: PERFORMANCES_VIEW_CURRENT,
}

export default function eventgroupPage(state = defaultState, action) {
  switch (action.type) {
    case actions.EVENT_GROUP_SET_PERFORMANCES_VIEW_TYPE:
      return {
        ...state,
        performancesViewType: action.viewType,
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/eventgroup-page/eventgroup-page.js
 **/